import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route } from 'react-router';
import './CustomRoute.scss';
import { replace } from 'connected-react-router';

/**
 * Automatic backward to the homescreen, if a pages is navigated to, without a searchterm.
 */
class CustomRoute extends Component<{ path: string, component: any, searchTerm: string, home: any }, {}> {

  componentWillMount() {
    if (this.props.searchTerm.length <= 0) {
      this.props.home();
    }
  }

  /**
   * Main render method
   */
  render() {
    return (
      <Route exact path={this.props.path} component={this.props.component} />
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    searchTerm: state.result.searchTerm
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    home() {
      dispatch(replace('/'))
    }
  }
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomRoute);